import { req } from "@/api/api_request";
import qs from "qs";
import { GetRequest } from "@/utils/utils";

const origin = location.origin;
const isProd = process.env.NODE_ENV === "production";

function checkUserLogin() {
  return req.get(`auth/checkUserLogin`);
}

// 获取客户端信息
function getClient(username) {
  let host = GetRequest("host") || location.host;
  return req.get(
    `anonymous/getClient?appId=12&serverName=${host}&username=${username}`,
    { auth: false }
  );
}

// 获取项目信息信息
function getProjectInfo(projectId, token) {
  return req.get(`auth/getProjectInfo?projectId=${projectId}`);
}

// 登录
function login(data) {
  return req.post("oauth/token", qs.stringify(data), { auth: false });
}

// 获取用户信息
function getAuthUserInfo(proId) {
  return req.get("auth/getUserInfo?proId=" + proId);
}

// 获取用户权限
function getUserMenuPower() {
  // PC端12 大屏端52
  let url = `auth/getUserMenuPower?appId=52`;
  return req.get(url);
}

// 获取项目名称
function getProjectName() {
  let host = GetRequest("host") || location.host;
  return req.get(`anonymous/getProjectName?appId=12&serverName=${host}`, {
    auth: false
  });
}

function getStations(group_id) {
  return req.get(`wz_api_php/api/wz/getStations/${group_id}`);
}

function getStationDataTimeSlot({
  alltype,
  station_id,
  start_time,
  end_time,
  time_type
}) {
  let url = `wz_api_php/api/wz/getStationDataTimeSlot?alltype=${alltype}&station_id=${station_id}&start_time=${start_time}&end_time=${end_time}&time_type=${time_type}`;
  return req.get(url);
}

function getStationRank({ groups, time_type, timepoint }) {
  let url = `wz_api_php/api/yc2/getStationRank?groups=${groups}&time_type=${time_type}&timepoint=${timepoint}`;
  return req.get(url);
}

function getAlarmList({ start, end, groups }) {
  let url = `wz_api_php/api/session/getAlarmList?start_t=${start}&end_t=${end}&groups=${groups}`;
  return req.get(url);
}

function getStationCurStatus({ group_id }) {
  let url = `wz_api_php/api/session/getStationCurStatus?groupid=${group_id}&type_ids=2`;
  return req.get(url);
}

function getStationData({ time, time_type, group_id }) {
  let url = `wz_api_php/api/wz/getStationData?station_type=wz&time=${time}&data_type=all&time_type=${time_type}&group_id=${group_id}`;
  return req.get(url);
}

function getStationSampleDevice(station_name) {
  if (!station_name) {
    return req.get((isProd ? origin : "") + "/py_web_api/station/sampleDevice");
  } else {
    return req.get(
      (isProd ? origin : "") +
        `/py_web_api/station/sampleDevice?sname=${station_name}`
    );
  }
}

function getStationSampleRecords(sname) {
  return req.get(
    (isProd ? origin : "") + `/py_web_api/station/sampleRecords?sname=${sname}`
  );
}

function getGfStaions(regionId) {
  const url = `http://gf.novaecs.com/api/gf_manage/station/?region_id=${regionId}&station_type=水质`;
  return req.get(url);
}

function getGfStationData(regionId) {
  let sensorType =
    "cod,cod_cr,cod_mn,ammonia_nitrogen,turbidity,water_temperature,dissolved_oxygen,ph,conductivity,zn,zp";
  const url = `http://gf.novaecs.com/api/gf_manage/station_data/?region_id=${regionId}&station_type=水质&data_type=${sensorType}`;
  return req.get(url);
}

export {
  checkUserLogin,
  getClient,
  getProjectInfo,
  getProjectName,
  login,
  getAuthUserInfo,
  getUserMenuPower,
  getStations,
  getStationDataTimeSlot,
  getStationRank,
  getAlarmList,
  getStationCurStatus,
  getStationData,
  getStationSampleDevice,
  getStationSampleRecords,
  getGfStaions,
  getGfStationData
};
